module.exports = __webpack_public_path__ + "static/media/gy.41725ef9.svg";